import Typography from '@components/v2/ui/Typography/Typography';
import { Skeleton } from '@mui/material';
import { ShowroomTestIds } from '../../utils/testIds/Showroom.testIds';

type AboutDescriptionProps = {
  title: string;
  description: string;
  loading?: boolean;
};
const AboutDescription = ({ title, description, loading }: AboutDescriptionProps) => (
  <>
    <Typography
      gutterBottom
      variant="h5"
      color="text.primary"
      testId={ShowroomTestIds.ABOUT_DETAILS}
    >
      {loading ? <Skeleton variant="text" /> : title}
    </Typography>
    <Typography variant="body1" color="text.primary" testId={ShowroomTestIds.ABOUT_TEXT_DETAILS}>
      {loading ? <Skeleton variant="text" /> : description}
    </Typography>
  </>
);

export default AboutDescription;
